export default "__VITE_ASSET__Cl$L_306__"